export default "__VITE_ASSET__C5CQC$8Y__"